<template>
  <NavigationTemplateList>
    <NavigationButtonIcon
      key="mon-programme"
      :url="route.path"
      label="Mon programme"
    />
    <NavigationButtonShortcut
      v-for="shortcut in shortcuts"
      :key="shortcut.id"
      :category="shortcut"
    />
  </NavigationTemplateList>
</template>
<script lang="ts" setup>
interface Props {
  shortcuts: CategorySchema[];
}

defineProps({
  shortcuts: null
});

const route = useRoute();
</script>
<style lang="scss" scoped>
.button-nomad {
  margin-bottom: var(--gap_m);
}
.nav {
  flex-direction: column;
  justify-content: flex-start;
  gap: var(--gap_xs);
  width: 100%;
  :deep(.button-base) {
    align-self: stretch;
  }
}
</style>
